import React from "react";
import Select from "react-select";
import Utils from "../../Utils";
import { useStyles } from "../AssetDetails/AssetDetailsFormStyles";
import useAssetProvider from "../useAssetProvider";

const VendorSelect = ({ setVendor }) => {
  const { vendors } = useAssetProvider();
  const classes = useStyles();
  const mappedVendors = vendors?.map((vendor) => {
    return {
      value: vendor.id,
      label: vendor.name,
      vendor: vendor,
    };
  });
  let sortedVendors = mappedVendors.sort((a, b) => Utils.compare(a, b));
  return (
    <Select
      id="vendorSelect"
      styles={classes.vendorSelectStyle}
      options={sortedVendors}
      onChange={(e) => setVendor(e.vendor)}
      isSearchable
    />
  );
};
export default VendorSelect;
